import { useMemo } from 'react';
import { biLogger } from '../../../services/biLogger';

export enum NotificationMessages {
  DeleteFailed = 'delete_failed',
  DeleteSuccess = 'delete_success',
  DeleteModal = 'delete_modal',
  DownloadFailedNoFile = 'download_failed_no_file',
  DownloadFailed = 'download_failed',
  ServerErrorMyVideos = 'server_error_my_videos',
  NoVideoFilesMyVideos = 'no_video_files_my_videos',
}

interface ITrackErrorShown {
  errorMessage: NotificationMessages;
  fileId?: string;
}

export enum NotificationButtons {
  Close = 'close',
  TryAgain = 'try_again',
  RefreshPage = 'refresh_page',
  Ok = 'ok',
  Cancel = 'cancel',
}

interface ITrackErrorClick extends ITrackErrorShown {
  buttonName: NotificationButtons;
}

export const useTrackNotificationInteraction = () =>
  useMemo(
    () => ({
      trackErrorClick: ({
        buttonName,
        errorMessage,
        fileId,
      }: ITrackErrorClick) =>
        biLogger.videoMakerErrorClick({
          buttonName,
          errorMessage,
          videoId: fileId,
        }),
      trackErrorShown: ({ errorMessage, fileId }: ITrackErrorShown) =>
        biLogger.videoMakerErrorShown({
          errorMessage,
          videoId: fileId,
        }),
    }),
    [],
  );
